import moment from 'moment';
import { CredentialWithVerification } from 'types';
import { examTypesMissouri } from 'utils/enums';

export const buildCredentialString = (credential: CredentialWithVerification): string => {
  const {
    state,
    status,
    subject,
    grade,
    license_number: licenseNumber,
    issue_date: issueDate,
    expiration_date: expirationDate,
    credential_exams_passed: credentialExamsPassed,
    credential_explanation: credentialExplanation,
  } = credential;

  const credentialStringParts: string[] = [state || 'Other Credential'];

  if (status) {
    credentialStringParts.push(`Status/Type: ${status}`);
  }

  if (subject) {
    credentialStringParts.push(`Category: ${subject}`);
  }

  if (grade) {
    credentialStringParts.push(`Grade Level: ${grade}`);
  }

  if (licenseNumber) {
    credentialStringParts.push(`License Number: ${licenseNumber}`);
  }

  if (issueDate) {
    credentialStringParts.push(`Issue date: ${moment(issueDate).format('MM/D/YYYY')}`);
  }

  if (expirationDate) {
    credentialStringParts.push(`Expiration date: ${moment(expirationDate).format('MM/D/YYYY')}`);
  }

  if (credentialExplanation) {
    credentialStringParts.push(`Candidate Explanation: ${credentialExplanation}`);
  }

  if (credentialExamsPassed) {
    const examTypesMissouriArray = examTypesMissouri();
    const examLabels = credentialExamsPassed
      .map((item) => examTypesMissouriArray.find((a) => a.value === item)?.label)
      .filter(Boolean);

    if (examLabels.length > 0) {
      credentialStringParts.push(`Exams Passed: ${examLabels.join('; ')}`);
    }
  }

  return credentialStringParts.join(' -- ');
};
